<template>
  <div class="banner-background">
    <template v-if="backgroundImage">
      <!-- 
      If browser doesn't support `object-fit: cover` on an `<img>` element,
      we need to use a `<div>` with a `background-image` and `background-size: cover`.
    -->
      <img 
        v-if="browserSupportsObjectFit"
        :src="backgroundImage" 
        :alt="altText"
        :class="{ 'opacity-0': !isLoaded }"
        class="banner-background__image" 
        @load="onLoad"
      >
      <div
        v-else
        :style="divStyle"
        class="banner-background__image css-only"
      />
    </template>

    <div class="banner-background__overlay" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import STATE from "Constants/campaign/civicactioncenter/state";

export default {
  name: "BannerBackground",
  data() {
    return {
      browserSupportsObjectFit: "objectFit" in document.documentElement.style,
      isLoaded: false
    };
  },
  computed: {
    ...mapState(STATE.SCOPE_CAMPAIGN, {
      altText: STATE.BANNER_IMAGE_ALT_TEXT,
      backgroundImage: STATE.BANNER_IMAGE
    }),
    divStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`
      };
    }
  },
  methods: {
    onLoad() {
      this.isLoaded = true;
    }
  }
};
</script>
